/**
 * The MyBooks mark: the blue X on white in light mode, the white X on the blue tile in dark mode
 * (public/logo-light.png, logo-dark.png). Both are rendered and the stylesheet shows the one for the
 * current theme, so it follows the device or the user's own choice. Decorative: the link or heading
 * around it carries the name.
 */
export function Logo({ size }: { size?: number }) {
  return (
    <span className="logo" style={size ? { width: size, height: size } : undefined}>
      <img className="logo-light" src="/logo-light.png" alt="" draggable={false} />
      <img className="logo-dark" src="/logo-dark.png" alt="" draggable={false} />
    </span>
  );
}
